// 'use strict'

let articles = {}

articles.Article = function(data) {
	data = data || {}
	var lemma = m.prop(data.term)
  var dict = data.dict
  var status = m.prop(data.status)
  var category = m.prop(data.category)
  var translations = m.prop([])
  if (Array.isArray(data.tg)) data.tg.forEach(function(item) {translations().push(new articles.Translation(item))})
  else if (data.tg) translations().push(new articles.Translation(data.tg))

  return {lemma: lemma, dict:dict, status:status, category:category, translations: translations}
}

articles.Translation = function(data) {
    var lang = m.prop(data.lang)
    var tr = m.prop([])
		var publicAPI = function(xhr) {xhr.withCredentials = false;}


	if (typeof data.t == 'string') {
		tr().push({ lemma: m.prop(data.t), pos: m.prop('') })
	}
	else if (Object.prototype.toString.call(data.t) == '[object Array]') {
		data.t.forEach(function(item) {
			if (item.pos == undefined) tr().push({ lemma: m.prop(item), pos: m.prop('') })
			else tr().push({ lemma: m.prop(item.text), pos: m.prop(item.pos) })
		})
	}
	else if (typeof data.t == 'object') {
		tr().push({ lemma: m.prop(data.t.text), pos: m.prop(data.t.pos) })
	}

	// tr().map(function(t) {
	// 	return m.request({
	// 		method: 'GET',
	// 		url: 'http://sanit.oahpa.no/paradigm/' + lang() + "/" + "nob" + "/" + t.lemma(),
	// 		config : publicAPI,
	// 		deserialize: function(data) {
	// 			console.log(data)
	// 		}
	// 	})
	// })

    return {lang: lang, tr: tr}
}

articles.view = function(ctrl, args) {
	return m("div", [
		args.data().filter(args.filter).map(item => {
      return m(".article", [
        m("p.dictname",
          args.dictlist()
          .find(dict => dict.id() == item.dict)
          .name()
          .find(dict => dict.lang == mx.translate.use())
          .name),
        m("p.lemma", item.lemma()),
				m.trust("<br/>"),
        m("p", item.status()),
				m.trust("<br/>"),
        m("p", mx.translate('modules.class.' + item.category())),
        item.translations().map(function(tr) {
          return m(".row.translation", [
            m("p.col-md-1.trans-lang", mx.translate('modules.localization.' + tr.lang())),
            tr.tr().map(function(tr) {
              return [
              	m("p.trans-lemma", tr.lemma()),
              	m("p.pos", tr.pos()),
              	m.trust("<br/>")
              ]
            })
          ])
        })
      ])
    })
	])
}

export default articles
